module.exports = __webpack_public_path__ + "img/nebula.60abcd6b.jpg";